(function ($) {
  var elementorHookRegistered = false;
  var widgetSelector = '[data-related-posts]';
  var sliderSelector = '[data-related-posts-slider]';
  var leftArrowMarkup = '<button type="button" class="slick-prev"><svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="44" cy="44" r="44" fill="#FFFFFF"/><path d="M25 43.6667H62.3333M62.3333 43.6667L43.6667 25M62.3333 43.6667L43.6667 62.3333" stroke="black" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
  var rightArrowMarkup = '<button type="button" class="slick-next"><svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="44" cy="44" r="44" fill="#FFFFFF"/><path d="M25 43.6667H62.3333M62.3333 43.6667L43.6667 25M62.3333 43.6667L43.6667 62.3333" stroke="black" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';

  function getRelatedPostsWidgets($scope) {
    if ($scope.is(widgetSelector)) {
      return $scope;
    }

    return $scope.find(widgetSelector);
  }

  function initRelatedPosts($scope) {
    getRelatedPostsWidgets($scope).each(function () {
      $(this).find(sliderSelector).each(function () {
        var $slider = $(this);

        if ($slider.hasClass('slick-initialized')) {
          return;
        }

        $slider.slick({
          autoplay: false,
          arrows: true,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          prevArrow: leftArrowMarkup,
          nextArrow: rightArrowMarkup,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      });
    });
  }

  function registerElementorHook() {
    if (
      elementorHookRegistered ||
      !window.elementorFrontend ||
      !window.elementorFrontend.hooks
    ) {
      return;
    }

    elementorHookRegistered = true;

    window.elementorFrontend.hooks.addAction(
      'frontend/element_ready/related-posts.default',
      initRelatedPosts
    );
  }

  $(window).on('elementor/frontend/init', registerElementorHook);

  $(function () {
    registerElementorHook();
    initRelatedPosts($(document));
  });
})(jQuery);
